import React from 'react'
import {routes} from 'routes/routes'
import {LocalLink} from 'i18n/LocalLink'
import {useI18n} from 'i18n/I18nContext'

type GuestNavActionsProps = {
  /** Narrow header: stack links vertically. */
  stacked?: boolean
}

export function GuestNavActions(props: GuestNavActionsProps) {
  const {t} = useI18n()
  const className = props.stacked
    ? 'app__header-auth-ctas app__header-auth-ctas--stacked'
    : 'app__header-auth-ctas'

  return (
    <div className={className}>
      <LocalLink
        to={routes.organization.newEvent}
        className="app__header-organizers-link app__header-organizers-link--desktop-only"
      >
        {t('menu.createEvent')}
      </LocalLink>
      <LocalLink to={routes.login} className="fill__btn app__header-login-btn">
        {t('common.login')} <i className="fa-regular fa-angle-right" />
      </LocalLink>
    </div>
  )
}
